import React from 'react';
import { Database, Crown, Sparkles, Home, Gift, ArrowLeft, ArrowRight, Save, Loader2 } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { EditorCard, Switch } from './ui';

const Row = ({ Icon, color, title, desc, children }) => (
  <div className="flex items-center gap-3 py-3 border-b border-slate-100 last:border-b-0">
    <span className={`w-9 h-9 shrink-0 rounded-lg flex items-center justify-center ${color}`}><Icon className="w-4 h-4" /></span>
    <div className="flex-1 min-w-0">
      <div className="text-sm font-bold text-slate-900">{title}</div>
      <div className="text-xs text-slate-500">{desc}</div>
    </div>
    {children}
  </div>
);

export const StatusCard = ({ form, set, onContinue, onDraft, busy, progress }) => {
  const { lang, isRTL } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const Arrow = isRTL ? ArrowLeft : ArrowRight;
  return (
    <EditorCard testId="course-status-card" Icon={Database} title={L('حالة الكورس', 'Course status')} desc={L('تحكم في حالة الكورس وإعدادات النشر', 'Control course status and publishing')}>
      <Row Icon={Sparkles} color="bg-blue-50 text-blue-600" title={L('منشور', 'Published')} desc={L('الكورس سيكون متاحاً للطلاب', 'Visible to students')}>
        <Switch checked={form.published} onChange={v => set('published', v)} testId="course-published-switch" />
      </Row>
      <Row Icon={Crown} color="bg-amber-50 text-amber-500" title={L('مميز', 'Featured')} desc={L('يظهر بشارة «مميز» وفي أول القائمة', 'Shows a badge and appears first')}>
        <Switch checked={form.featured} onChange={v => set('featured', v)} testId="course-featured-switch" />
      </Row>
      <Row Icon={Home} color="bg-emerald-50 text-emerald-600" title={L('إظهار في الرئيسية', 'Show on home')} desc={L('عرض الكورس في الصفحة الرئيسية', 'Display on the home page')}>
        <Switch checked={form.show_home} onChange={v => set('show_home', v)} testId="course-home-switch" />
      </Row>
      <Row Icon={Gift} color="bg-rose-50 text-rose-500" title={L('كورس مجاني', 'Free course')} desc={L('متاح للجميع بدون اشتراك', 'Available without a subscription')}>
        <Switch checked={form.is_free} onChange={v => set('is_free', v)} testId="course-free-switch" />
      </Row>
      {busy && progress > 0 && <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden mt-3"><div className="h-full bg-blue-600 transition-[width]" style={{ width: `${progress}%` }} /></div>}
      <button type="button" data-testid="course-continue-btn" disabled={busy} onClick={onContinue}
        className="mt-4 w-full h-12 rounded-xl bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white font-bold inline-flex items-center justify-center gap-2 transition-colors">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}{L('حفظ ومتابعة إلى المحتوى والدروس', 'Save & continue to content')}<Arrow className="w-4 h-4" />
      </button>
      <button type="button" data-testid="course-draft-btn" disabled={busy} onClick={onDraft}
        className="mt-2 w-full h-11 rounded-xl bg-slate-50 hover:bg-slate-100 border border-slate-200 text-slate-700 font-bold text-sm inline-flex items-center justify-center gap-2 transition-colors">
        <Save className="w-4 h-4" />{L('حفظ كمسودة', 'Save as draft')}
      </button>
    </EditorCard>
  );
};
